<script lang="ts">
	import 'styles/base.scss';
	import { onMount } from 'svelte';
	import theme from 'stores/theme';
	import Header from 'components/Header/Header.svelte';
	import Footer from 'components/Footer/Footer.svelte';
	import { page } from '$app/stores';
	import { goto } from '$app/navigation';
	import token from 'stores/token';
	import { validate } from 'services/auth/validate';
	import userStore from 'stores/user';
	import { browser } from '$app/environment';
	// import { webVitals } from '$lib/vitals';
	// import { inject } from '@vercel/analytics';
	// import { dev } from '$app/environment';
	// inject({ mode: dev ? 'development' : 'production' });

	// const analyticsId = import.meta.env.VERCEL_ANALYTICS_ID;
	// $: if (browser && analyticsId) {
	// 	webVitals({
	// 		path: $page.url.pathname,
	// 		params: $page.params,
	// 		analyticsId,
	// 	});
	// }

	// if (typeof window !== 'undefined') {
	// // client-only code here
	// 	if ('serviceWorker' in navigator) {
	// 		addEventListener('load', function () {
	// 			navigator.serviceWorker
	// 				.register('/service-worker.js')
	// 				.catch(console.error.bind(console));
	// 		});
	// 	}
	// }

	const getUserData = async () => {
		if (!browser) return;
		if ($token) {
			await validate($token);
		}
	};

	onMount(async () => {
		await getUserData();
		if (
			!$userStore.isLoggedIn &&
			($page.url.pathname.includes('/account') ||
				$page.url.pathname.includes('/portfolio') ||
				$page.url.pathname.includes('/newsletter/settings'))
		) {
			await goto('/');
		}
	});

	$: dark = $theme;
</script>

<svelte:head>
	{@html `
	<link rel="dns-prefetch" href="//cdn.coinranking.com">
	<link rel="preconnect" href="//cdn.coinranking.com" crossorigin="anonymous">
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-Q27BTS2V21"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag(){window.dataLayer.push(arguments);}
		gtag('js', new Date());

		gtag('config', 'G-Q27BTS2V21');
	</script>
	`}
</svelte:head>

<div class={`content ${dark ? 'dark' : ''}`}>
	<Header {dark} />

	<main class="main">
		<slot />
	</main>

	<Footer />
</div>

<style lang="scss">
	.content {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
	.main {
		flex: 1;
	}
</style>
